import { useEffect, useRef, useState } from 'react';
import type { FC } from 'react';

const BANNER_HOSTNAMES = ['adminbeta.movatic.co'];
const PRODUCTION_URL = 'https://admin.movatic.co';

const BetaBanner: FC = () => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(36);
  const shouldShow = BANNER_HOSTNAMES.includes(window.location.hostname);

  useEffect(() => {
    if (!shouldShow || !bannerRef.current) return;
    const element = bannerRef.current;
    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry.contentRect.height);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [shouldShow]);

  if (!shouldShow) return null;

  return (
    <>
      <style>{`
        body { padding-top: ${height}px; }
        .MuiDrawer-paper { top: ${height}px !important; }
      `}</style>
      <div
        ref={bannerRef}
        role="banner"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px 16px',
          backgroundColor: '#FFC107',
          color: '#1F1F1F',
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          fontSize: 13,
          fontWeight: 500,
          lineHeight: 1.3,
          textAlign: 'center',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
        }}
      >
        <span>
          You are currently using an experimental environment (Beta). For a more
          reliable experience, use the production site:{' '}
          <a
            href={PRODUCTION_URL}
            style={{ color: '#1F1F1F', textDecoration: 'underline', fontWeight: 600 }}
          >
            admin.movatic.co
          </a>
        </span>
      </div>
    </>
  );
};

export default BetaBanner;
